/**
 * React Query hooks for Referrer operations.
 */

import { useQuery, keepPreviousData } from '@tanstack/react-query';
import referrerService from '../services/referrer.service';

interface UseReferrerListQueryParams {
  workspaceId?: string;
  idToken: string | undefined;
  page?: number;
  size?: number;
  sortBy?: string;
  order?: 'asc' | 'desc';
  search?: string;
  enabled?: boolean;
  refetchInterval?: number | false;
}

export const useReferrerListQuery = ({
  workspaceId,
  idToken,
  page = 1,
  size = 100,
  sortBy = 'name',
  order = 'asc',
  search,
  enabled = true,
  refetchInterval = false,
}: UseReferrerListQueryParams) => {
  return useQuery({
    queryKey: ['referrers', workspaceId, page, size, sortBy, order, search],
    queryFn: async () => {
      if (!workspaceId || !idToken) {
        throw new Error('Workspace ID and token are required');
      }

      return await referrerService.listReferrers(workspaceId, idToken, {
        page,
        size,
        sortBy,
        order,
        search,
      });
    },
    enabled: enabled && !!workspaceId && !!idToken,
    placeholderData: keepPreviousData,
    refetchInterval,
    staleTime: 30000,
  });
};
